import { HttpStatusCode } from '@/common/util/status'

import Button from '@/components/view/atoms/button/Button'
import Text, { TextColor } from '@/components/view/atoms/text/Text'
import GuidanceAreaContent from '@/components/view/layouts/area/GuidanceAreaContent'
import ButtonList from '@/components/view/layouts/button/ButtonList'
import Main from '@/components/view/layouts/page/Main'
import Image from '@/components/view/utils/image/Image'

interface Props {
  status: HttpStatusCode | number
  noNavi?: boolean
}

const errorImagePath = (status: HttpStatusCode | number) => {
  return status == HttpStatusCode.NOT_FOUND
    ? '/assets/images/404.png'
    : status == HttpStatusCode.UNAUTHORIZED
      ? '/assets/images/access-error.png'
      : '/assets/images/system-error.png'
}

export const ErrorPageInner = ({ status }: { status: HttpStatusCode | number }) => {
  return (
    <GuidanceAreaContent>
      <Image src={errorImagePath(status)} width={400} height={400} />
      <div className='-mt-16 flex flex-col gap-6'>
        <Text size={32} weight='bold' align='center' tag='p'>
          {status == HttpStatusCode.NOT_FOUND
            ? 'お探しのページが見当たりません'
            : status == HttpStatusCode.UNAUTHORIZED
              ? 'アクセス権限がありません'
              : 'システムエラーが発生しました'}
        </Text>
        <Text align='center' tag='p' color={TextColor.SECONDARY} lineHeight={150}>
          {status == HttpStatusCode.NOT_FOUND ? (
            <>
              ページが削除されたか、有効期限が切れている場合があります。
              <br />
              URLを確認して、もう一度お試しください。または、下のボタンから再度お探しください。
            </>
          ) : status == HttpStatusCode.UNAUTHORIZED ? (
            <>このページにアクセスするには、管理者に権限を確認してください。</>
          ) : (
            <>
              大変お手数ですが、時間をおいて再度アクセスを試みるか、サイト管理者までご連絡ください。
            </>
          )}
        </Text>
        <ButtonList>
          <Button size='large' link={'/'} color={'secondary'}>
            ホーム画面へ戻る
          </Button>
          {status != HttpStatusCode.NOT_FOUND && status != HttpStatusCode.UNAUTHORIZED && (
            <Button size='large' link={'/'} color={'secondary'}>
              お問い合わせはこちら
            </Button>
          )}
        </ButtonList>
      </div>
    </GuidanceAreaContent>
  )
}

const ErrorPage = ({ status, noNavi = false }: Props) => {
  return (
    <Main noNavi={noNavi}>
      <ErrorPageInner status={status} />
    </Main>
  )
}

export default ErrorPage
